














































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FileReaderInput extends Vue {
  @Prop() private error?: boolean;
  @Prop() private file!: File;
  private fileUploaded: boolean = !!this.file;
  private hovering: boolean = false;
  private defaultLabel = "Drag and drop or click here to upload a .csv file";
  private label: string = this.file
    ? this.file.name
    : this.defaultLabel;

  private removeFile() {

    this.$emit("load", null, null);
    this.label = this.defaultLabel;
    this.fileUploaded = false;
  }

  private chooseFile() {
    
    console.log("chooseFile")
    if(!this.fileUploaded) {
      let inputFileElement = this.$refs.file as HTMLElement;
      inputFileElement.click();
    }
  }

  private selectFileEvent(event: any) {
    this.hovering = false;
    if(event.target) {
      let files = event.target.files;
      if (files.length) {
        let file = event.target.files[0];
        this.uploadFile(file);
      }
      event.target.value = ''
    }
  }

  private uploadFile(file: File) {

    const reader: any = new FileReader();
    if(reader) {
      this.label = file.name;
      reader.onload = (e: any) => {
        this.$emit("load", e.target.result, file);
        this.fileUploaded = true;
      };
      reader.onerror = (er: any) => {
        console.log("FILE READER ERROR", er);
        reader.abort();
      };
      reader.readAsText(file, "utf-8");
    }
  }

  private handleDrop(e: DragEvent) {
    this.eventCancel(e);
    this.hovering = false;
    
    if (e.dataTransfer) {
      let file = e.dataTransfer.files[0];
      this.uploadFile(file)
    }
  }

  private handleDragEnter(e: DragEvent) {
    this.eventCancel(e);
    if (!this.hovering) {
      this.hovering = true;
    }
  }

  private handleDragLeave(e: DragEvent) {
    this.eventCancel(e);
    if (this.hovering) {
      this.hovering = false;
    }
  }

  private eventCancel(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
  }
}
